module.exports = __webpack_public_path__ + "img/amami.b49fc1a8.svg";